export default __webpack_public_path__ + "assets/thunderstorms-night-snow.bb79cce4.svg";